import { snowplowButtonClick } from '@analytics/snowplow/events';
import useCurrentYear from '@hooks/use-current-year';
import AppLinks from '@screens/lp-default/components/footer/components/app-links';
import SocialLinks from '@screens/lp-default/components/footer/components/social-links';
import { footerLinks } from '@screens/lp-default/components/footer/constants';
import * as Styles from '@screens/lp-default/components/footer/styles';

export default function Footer() {
  const currentYear = useCurrentYear();
  const handleLinkClick = (linkName: string) => {
    snowplowButtonClick('hyperlink', '/planos', linkName, 'footer');
  };

  return (
    <Styles.FooterContainer data-testid="footer">
      <Styles.Footer>
        <Styles.FooterSide>
          <Styles.FooterLogo>
            <img src="/images/whitebook-logo-100-100.webp" width={36} height={36} alt="" />
            <img src="/images/default-landing-page/logo-wb-colored-white.svg" alt="Logo do Whitebook Afya" />
          </Styles.FooterLogo>
          <Styles.FooterSeal
            src="/images/default-landing-page/selo-reclame-aqui.webp"
            alt="Selo RA 1000 do Reclame Aqui"
          />
          <Styles.FooterCopy>© {currentYear} Afya Participações S.A.</Styles.FooterCopy>
        </Styles.FooterSide>
        <Styles.FooterMain>
          {footerLinks.map((section) => (
            <Styles.FooterColumn key={section.title}>
              <Styles.FooterTitle>{section.title}</Styles.FooterTitle>
              {section.links.map((link) => (
                <Styles.FooterLink
                  href={link.href}
                  key={link.text}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => handleLinkClick(link.text)}
                >
                  {link.text}
                </Styles.FooterLink>
              ))}
            </Styles.FooterColumn>
          ))}
        </Styles.FooterMain>
        <Styles.FooterSide>
          <Styles.FooterSideLinks>
            <Styles.FooterTitle>Redes sociais</Styles.FooterTitle>
            <SocialLinks />
          </Styles.FooterSideLinks>
          <Styles.FooterSideLinks>
            <Styles.FooterTitle>Baixe o app</Styles.FooterTitle>
            <AppLinks />
          </Styles.FooterSideLinks>
        </Styles.FooterSide>
      </Styles.Footer>
    </Styles.FooterContainer>
  );
}
